module.exports = __webpack_public_path__ + "static/report/img/w7.34613f2e.png";